import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface BreadcrumbItem {
  label: string;
  to?:   string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export const Breadcrumb = ({ items }: BreadcrumbProps) => {
  const { t } = useTranslation();
  return (
    <nav
      aria-label={t('jurisprudence.breadcrumb_aria')}
      className="w-full border-b border-border/60 bg-background"
    >
      <div className="w-full px-3 sm:px-8 h-9 flex items-center gap-1.5 text-[12px] text-muted-foreground">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <span key={i} className="flex items-center gap-1.5">
              {i > 0 && (
                <span className="text-muted-foreground/40 text-[10px]">›</span>
              )}
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-primary font-medium' : ''}>
                  {item.label}
                </span>
              )}
            </span>
          );
        })}
      </div>
    </nav>
  );
};